import AirdomeAccess from '../../../base/forms/user/AirdomeAccess';

const airdomeAccess: AirdomeAccess = {
  header: 'Hallenaccess',
  submit: 'Bestätigen'
};

export default airdomeAccess;
